import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { PlantListTable } from './plant-list-table/plant-list-table';
import { PlantMap } from './plant-map/plant-map';
import { PlantStatusGraph } from './plant-status-graph/plant-status-graph';
import { Savings } from './savings/savings';
import { OverviewTable } from './overview-table/overview-table';

@Component({
    selector: 'app-old-version-dasboard',
    imports: [MatButtonModule, MatCardModule, MatMenuModule, PlantListTable, PlantMap, PlantStatusGraph, Savings, OverviewTable],
    templateUrl: './old-version-dasboard.component.html',
    styleUrl: './old-version-dasboard.component.scss'
})
export class OldVersionDasboardComponent {}
